import React from 'react';
import { Analytics } from '@vercel/analytics/react';
import { useTermlyConsentCategory } from '../../hooks/useTermlyConsentCategory';

/**
 * Vercel Analytics is injected at runtime and is not covered by Termly Auto Blocker.
 * Mount only after the visitor opts into analytics cookies.
 */
const ConsentGatedAnalytics: React.FC = () => {
  const analyticsConsented = useTermlyConsentCategory('analytics');

  if (!analyticsConsented) {
    return null;
  }

  return <Analytics />;
};

ConsentGatedAnalytics.displayName = 'ConsentGatedAnalytics';

export default ConsentGatedAnalytics;
